import { useState, useEffect } from 'react';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { CapTableSummary } from '@/components/ledger/CapTableSummary';
import ShareRegisterCard from '@/components/ledger/ShareRegisterCard';
import { SubscriptionAgreementList } from '@/components/ledger/SubscriptionAgreementList';
import { useTenantStore } from '@/hooks/useTenantStore';
import { useToast } from '@/hooks/use-toast';
import { useLedgerStream } from '@/hooks/useLedgerStream';
import * as CapLedgerService from '@/services/capLedgerService';

const Shareholders = () => {
  const { toast } = useToast();
  const { tenantId } = useTenantStore();
  const [capTable, setCapTable] = useState<CapLedgerService.CapTableSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const ledgerStream = useLedgerStream();

  useEffect(() => {
    fetchCapTable();

    const subscription = ledgerStream.subscribe(() => {
      fetchCapTable();
    });

    return () => subscription.unsubscribe();
  }, []);

  const fetchCapTable = async () => {
    setLoading(true);
    try {
      const data = await CapLedgerService.getCapTableSummary();
      setCapTable(data);
    } catch (error: any) {
      toast({
        title: 'Error loading cap table',
        description: error.message,
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Shareholders & Share Register</h1>
          <p className="text-muted-foreground">
            Cap table ownership summary and statutory share register
          </p>
        </div>

        <div data-tour="subscription-agreements">
          <SubscriptionAgreementList />
        </div>

        <div data-tour="shareholders-list">
          <CapTableSummary data={capTable} loading={loading} onEdit={fetchCapTable} />
        </div>

        {tenantId && (
          <div data-tour="export-actions">
            <ShareRegisterCard companyId={tenantId} />
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Shareholders;
